import { TTS_LANGUAGE_CODE_MAP } from '@loc/server/service/tts/tts-language-code.config'

export const TTS_MIN_TEXT_LENGTH = 5
export const TTS_MAX_TEXT_LENGTH = 5000
export const TTS_MAX_DIALOGUES = 10
export const TTS_DEFAULT_STABILITY = 0.5
export const TTS_DEFAULT_SPEECH_LANGUAGE = 'auto'
export const TTS_FORM_VOICE_DISPLAY_COUNT = 6

/**
 * Speech Language 下拉选项（纯语言数据，分组 label 在组件中国际化）
 */
export const TTS_ALL_LANGUAGE_OPTIONS = Object.entries(
  TTS_LANGUAGE_CODE_MAP,
).map(([label, value]) => ({
  value,
  label,
}))
